import { render, staticRenderFns } from "./stickyItem.vue?vue&type=template&id=1fd61129&scoped=true"
import script from "./stickyItem.vue?vue&type=script&setup=true&lang=js"
export * from "./stickyItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./stickyItem.vue?vue&type=style&index=0&id=1fd61129&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd61129",
  null
  
)

export default component.exports